<template>
  <div class="container mt-5 d-flex justify-content-center ">
    <div class="card d-flex  w-50 mt-5">
      <div class="d-flex flex-row justify-content-center mt-2 ">
        <div class="p-2"><h5 class="text-success" >پکیج ها به صورت اعتباری برای شما ثبت شد</h5></div>
      </div>
      <div class="d-flex flex-row justify-content-center">
<!--        <div class="p-2"> کد پیگیری اعتباری</div>-->
<!--        <div class="p-2">{{(code)? code : "" }}</div>-->
      </div>
      <div class="d-flex flex-row justify-content-center">
        <div class="p-2 ">
          <ul class="list-group ">
            <li class="list-group-item text-center ">
              <i class="fa fa-exclamation-triangle ms-2 text-warning"></i>
                 <span class="ms-2">فعال شدن کدهای تخفیف 20 دقیقه زمان می برد  </span> <br>
                <span class="ms-2">      کد پیگیری را نزد خود نگه دارید</span>
            </li>
             <li>
               <br>
                <h6>
                  برای مشاهد لیست کد های تخفیف
                  <router-link to="/agents/panel/discount" class="title  text-danger ">
                     <span class="title btn text-danger">اینجا</span>
                  </router-link>
                  کلیک کنید
                </h6>
             </li>

          </ul>
        </div>
      </div>

    </div>
  </div>
</template>
<script setup>

import {useStore} from 'vuex'
import {useRoute} from "vue-router";
import {$ref} from "vue/macros";
const store = useStore()

const route = useRoute()

let code = $ref(route.params.codeId);

store.commit('clearAll')



</script>
